import {forwardRef, useCallback, useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import cN from 'classnames';

import {gettext} from 'topmeteo/utils/i18n';

import {toggleFavourite, editLocation, deleteLocation} from 'topmeteo/loc/actionCreators';

import EventListener from 'topmeteo/general/components/EventListener';

const EditLocationTitle = gettext('Edit Location');
const DeleteLocationTitle = gettext('Delete Location');

const LocationManagerItem = ({className, style, innerRef, handle, location, editing, onToggle, onSetEditable, onEdit,
                                 onDelete, ...props}) => {
    const inputRef = useRef();
    const textRef = useRef();
    const {name: initialName, isFavourite} = location;
    const [draft, setDraft] = useState(initialName);
    const [width, setWidth] = useState(0);
    const handleDraftChange = event => setDraft(event.target.value);

    const handleKeyPress = useCallback(
        ({key}) => {
            if (!editing) return;

            if (key === 'Enter') {
                onEdit(draft);
                onSetEditable();
            }

            if (key === 'Escape') {
                setDraft(initialName);
                onSetEditable();
            }
        },
        [initialName, editing, draft, onEdit, onSetEditable, setDraft],
    );

    useEffect(() => {
        if (textRef.current) {
            setWidth(textRef.current.offsetWidth);
        }
    }, [editing]);

    return (
        <EventListener target={window} onKeyUp={handleKeyPress}>
            <li
                className={cN('location-manager-item', className)}
                ref={innerRef}
                style={style}
                {...props}
            >
                {handle}
                <strong className={cN('control mark-favorite icon-favourite', {none: !isFavourite})} onClick={onToggle} />
                {editing ? (
                    <input style={{width}} ref={inputRef} onChange={handleDraftChange} value={draft} autoFocus />
                ) : (
                    <span className="name" ref={textRef}>{draft}</span>
                )}
                <strong className="control icon-pencil" title={EditLocationTitle} onClick={onSetEditable} />
                <strong className="control icon-trash-empty" title={DeleteLocationTitle} onClick={onDelete} />
            </li>
        </EventListener>
    );
};

const mapDispatchToProps = (dispatch, {location: {id}}) => ({
    onToggle: () => dispatch(toggleFavourite(id)),
    onEdit: name => dispatch(editLocation(id, name)),
    onDelete: () => dispatch(deleteLocation(id)),
});

const ConnectedLocationManagerItem = connect(null, mapDispatchToProps)(LocationManagerItem);

export default forwardRef((props, ref) => <ConnectedLocationManagerItem {...props} innerRef={ref} />);
